import { render, staticRenderFns } from "./FONContactDetails.vue?vue&type=template&id=0aaeee74"
import script from "./FONContactDetails.vue?vue&type=script&lang=js"
export * from "./FONContactDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports